<div class="modal-header" appCustomAutofocus>
    <h3>Performance Reviewers: {{data.EmployeeName}} {{data.ReviewTemplateName}}</h3>
</div>
<div class="modal-body">
    <div style="position:fixed;text-align:left;z-index:100;margin-top:-25px;">
        <span *ngIf="lastSave.status == 'success' && lastSave.time != null" class="badge badge-success default" [ngClass]="{fade: formData.labelFade}">Save Successful - {{lastSave.time}}</span>
        <span *ngIf="lastSave.status == 'danger' && lastSave.time != null" class="badge badge-danger default" [ngClass]="{fade: formData.labelFade}">Save Fail - {{lastSave.time}}</span>
    </div>
    <div class="row">
        <div class="col-lg-6">
            <label><strong>Add New Reviewer</strong></label>
            <ng-select [(ngModel)]="formData.selectedReviewer"
                       [searchable]="true" [clearable]="false"
                       (change)="checkExisting()">
                <ng-option *ngFor="let data of reviewerAddList" [value]="data.KeyID">
                    {{data.FullName}}
                </ng-option>
            </ng-select>
        </div>
        <div class="col-lg-6">
            <button class="btn btn-success buttonNoLabel" type="button" (click)="addNewReviewer()" [disabled]="exist || formData.selectedReviewer == null">Add</button>
        </div>
    </div>
    <hr />
    <table class="table table-responsive-lg" style="margin-bottom:0px;" *ngIf="reviewerList.length > 0">
        <thead>
            <tr>
                <th>Reviewer</th>
                <th>Email</th>
                <th>Date Review Completed</th>
                <th>Link</th>
                <th>Score</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let data of reviewerList">
                <td>{{data.ReviewerFullName}}</td>
                <td>{{data.Email}}</td>
                <td>{{data.DateSubmittedDisplay}}</td>
                <td><a *ngIf="data.DateSubmitted != null && data.ChecklistInstanceID != null" href="/Performance/Form/#{{data.ChecklistInstanceID}}/Tab/M/Hide/T/Route/A">View</a></td>
                <td>{{data.ReviewerScore}}</td>
                <td>
                    <button class="btn btn-danger" type="button" (click)="unsubmitReviewer(data)" *ngIf="data.DateSubmitted != null">Unsubmit</button>
                    <button class="btn btn-danger btn-icon-only" type="button" (click)="removeReviewer(data)"><i class="modus-icons">close</i></button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="closeClicked()">Close</button>
</div>